import * as React from 'react';
import {createRoot} from 'react-dom/client';
import './index.scss';
import App from './App';
import ErrorApp from "./ErrorApp";
import { createClient } from '@reachfive/identity-core';
import {getCookie} from "./utils/utils";
import AppNewsletter from "./AppNewsletter";

if (process.env.REACT_APP_GET_LEAD_REACH5_CLIENT_ID === undefined
    || process.env.REACT_APP_GET_LEAD_REACH5_HOST === undefined
    || process.env.REACT_APP_GET_LEAD_BACKEND === undefined
) {
    throw new Error('REACT_APP_GET_LEAD_REACH5_CLIENT_ID is not defined. You may create a .env file in the root directory of the project.');
}

const clientId =  process.env.REACT_APP_GET_LEAD_REACH5_CLIENT_ID;
const host = process.env.REACT_APP_GET_LEAD_REACH5_HOST;
let backend =  process.env.REACT_APP_GET_LEAD_BACKEND;

const client = createClient({
    domain: host,
    clientId: clientId,
});

const getParam = (rootElement: HTMLElement, currentUrl: URL, attribute: string, defaultValue: string|null ) => {
    return rootElement.dataset.hasOwnProperty(attribute) && rootElement.dataset[attribute] ?
                rootElement.dataset[attribute] :
                    currentUrl.searchParams.get(attribute) ? currentUrl.searchParams.get(attribute) : defaultValue;
}

const rootElement = document.getElementById('get-lead');
const root = createRoot(rootElement!); 
if (rootElement) {
    const currentUrl = new URL(window.location.href);

    const origin = getParam(rootElement, currentUrl, 'origin', 'editions-tissot');
    const email = getParam(rootElement, currentUrl, 'email', decodeURIComponent(getCookie('gl-email') || ''));
    const activityItemId = getParam(rootElement, currentUrl, 'activityItemId', localStorage.getItem('activityItemId'));
    const codeAction = getParam(rootElement, currentUrl, 'cact', localStorage.getItem('codeAction'));
    const thirdPartyUrl = getParam(rootElement, currentUrl, 'thirdPartyUrl', null);
    const downloadUrl = thirdPartyUrl ? null : getParam(rootElement, currentUrl, 'downloadUrl', localStorage.getItem('downloadUrl'));
    const type = getParam(rootElement, currentUrl, 'type', 'download');
    const consent = getParam(rootElement, currentUrl, 'consent', null);
    const autofocus = getParam(rootElement, currentUrl, 'autofocus', 'true') === 'true';
    const account = getParam(rootElement, currentUrl, 'account', 'true') === 'true';

    if (activityItemId) {
        localStorage.setItem('activityItemId', activityItemId);
    }
    if (codeAction) {
        localStorage.setItem('codeAction', codeAction);
    }
    if (downloadUrl) {
        localStorage.setItem('downloadUrl', downloadUrl);
        localStorage.removeItem('thirdPartyUrl');
    }
    if (thirdPartyUrl) {
        localStorage.setItem('thirdPartyUrl', thirdPartyUrl);
        localStorage.removeItem('downloadUrl');
    }


    if (window.location.href.indexOf('lumio-rh.fr') > 0) {
        const preprod = window.location.href.indexOf('preprod') >= 0 ? '-preprod' : '';
        backend = `https://getlead${preprod}.lumio-rh.fr`;
    } else if (window.location.href.indexOf('bdes-online.fr') > 0) {
        //backend = `https://getlead${preprod}.bdes-online.fr`; // no preprod for bdes :-(
        backend = `https://getlead.bdes-online.fr`;
    }

    if (type === 'download' &&  activityItemId && codeAction && (downloadUrl || thirdPartyUrl)) {

        root.render(
          <React.StrictMode>
              <App
                  client={client} backend={backend}
                  origin={origin || ''}
                  email={email || ''}
                  activityItemId={ activityItemId }
                  codeAction={ codeAction }
                  downloadUrl={ downloadUrl || undefined }
                  thirdPartyUrl={thirdPartyUrl || undefined}
                  autofocus={ autofocus }
                  account={ account }
                  rootElement={rootElement}
              />
          </React.StrictMode>
        );
    } else if (type === 'newsletter' && consent) {

        root.render(
          <React.StrictMode>
              <AppNewsletter
                client={client} backend={backend}
                origin={origin || undefined}
                email={email || undefined}
                consent={consent}
                autofocus={autofocus}
              />
          </React.StrictMode>
        );
    } else {
        root.render(
          <React.StrictMode>
              <ErrorApp />
          </React.StrictMode>
        );
    }
}
